export const counterCardBySiteStyle = theme => ({
    containerCard: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: '0 16px',
        width: '100%'
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '95px',
        height: '95px',
        border: '1.5px solid #E6E6E6',
        margin: '0px 8px'
    },
    cardText: {
        margin: '0px',
        fontWeight: '800'
    }
});